const usersEndpoint = `${process.env.VUE_APP_URL}/api/v1/auth/users`;
export default {
  namespaced: true,
  state: {
    currentUser: {},
  },
  mutations: {
    SET_CURRENT_USER(state, data) {
      state.currentUser = data;
    },
  },
  actions: {
    getCurrentUser({ commit }, { context }) {
      return context.$http.get(`${usersEndpoint}/me/`)
        .then(res => {
          commit("SET_CURRENT_USER", res.data);
          return res.data;
        });
    },
    updateCurrentUser({ commit }, { context, user }) {
      console.log(user)
      context.$http.put(`${usersEndpoint}/me/`, user)
        .then(res => {
          commit("SET_CURRENT_USER", res.data);
        });
    },
    setPassword({ commit }, { context, data }) {
      return context.$http.post(`${usersEndpoint}/set_password/`, data)
    },
    postForgotPassword({ commit }, { context, email }) {
      
      let data = {email:email}

      return context.$http.post(`${usersEndpoint}/reset_password/`,data)
    },
    postResetPassword({ commit }, { context, data }) {

      return context.$http.post(`${usersEndpoint}/reset_password_confirm/`,data)
    },
  },
}
